export default __webpack_public_path__ + "static/media/Atta, Rice & Dal.89ab6e1e.png";